<template>
    <div class="checkbox-list">
        <base-checkbox
            v-bind:label="value.label"
            v-bind:value="value.value"
            v-bind:checked="value.checked"
            @checkboxUpdated="onChange($event)"
            :key="value.value"
            v-for="value in checkboxes"
        ></base-checkbox>
    </div>
</template>

<script lang="ts">
import { CheckboxUpdatedEvent } from "@/shared/models/checkbox";
import { Vue } from "vue-class-component";
import { Emit, Prop } from "vue-property-decorator";

export default class BaseCheckboxList extends Vue {
    @Prop() checkboxes: Array<unknown> = [];
    @Prop() selectedValues: Array<string | number> = [];

    @Emit("checkboxListUpdated")
    onChange(checkbox: CheckboxUpdatedEvent): Array<string | number> {
        const index = this.selectedValues.indexOf(checkbox.value);

        if (index > -1) {
            this.selectedValues.splice(index, 1);
        } else {
            this.selectedValues.push(checkbox.value);
        }

        return this.selectedValues;
    }
}
</script>

<style scoped></style>
